export default "__VITE_ASSET__CB09$4pS__"